import { render, staticRenderFns } from "./AddNewAuto.vue?vue&type=template&id=e1ef1526&"
import script from "./AddNewAuto.vue?vue&type=script&lang=js&"
export * from "./AddNewAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports